export function listCycleClosingByEmployee() {
  return `{
    listCycleClosingByEmployee {
        id
        cycleClosed
        cycleNumber
        cycleName
        schoolClass{ 
            id
            name 
            value 
            label
            term { name }
            courseStep { 
                id
                fullName
                value 
                label
                course { 
                  id 
                  name 
                  value 
                  label
                }
            }
        }
        subject { 
          id 
          name
        }
        professor {
          id 
          name
        }
    }
}`;
}

export function cycleClosingWrapperByCycleClosing(
  schoolClassId,
  subjectId,
  cycleNumber,
  courseStepId,
  courseId,
  cycleClosingId = 0
) {
  return `{
  cycleClosingWrapperByCycleClosing(
    cycleClosing: {
      id: ${cycleClosingId || 0}
      cycleNumber: ${cycleNumber}
      schoolClass: {
        id: ${schoolClassId}
        studentsQuantity: 0
        updaterId: 0
        year: 0
        active: true
        capacity: 0
        courseStep: {
            id: ${courseStepId}
            cycleQuantity: 0
            course: { 
                id: ${courseId}
                excluded:false, 
                updaterId: 0, 
                useGridSchedule: true, 
                active: true
            }
        }
      }
      subject: {
        id: ${subjectId}
        termFilterId: 0
        updaterId: 0
        subjectLevelFilterId: 0
        active: true
      }
    }
  ) {
    minGrade
    maxGrade
    minAverage
    closingData {
      studentId
      studentName
      average
      averageCopy
      classCouncil
      evaluations {
        evaluationDateKey
        evaluationTitle
        correctionId
        evaluationId
        grade
      }
    }
    headers {
      header
      evaluationTitles
    }
  }
}
`;
}

export function cycleClosingAttendanceWrapperByCycleClosing(
  schoolClassId,
  subjectId,
  cycleNumber,
  courseStepId,
  courseId
) {
  return `{
  cycleClosingAttendanceWrapperByCycleClosing(
    cycleClosing: {
      cycleNumber: ${cycleNumber}
      schoolClass: {
        id: ${schoolClassId}
        studentsQuantity: 0
        updaterId: 0
        year: 0
        active: true
        capacity: 0
        courseStep: {
          id: ${courseStepId}
          cycleQuantity: 0
          course: {
            id: ${courseId}
            excluded: false
            updaterId: 0
            useGridSchedule: true
            active: true
          }
        }
      }
      subject: {
        id: ${subjectId}
        termFilterId: 0
        updaterId: 0
        subjectLevelFilterId: 0
        active: true
      }
    }
  ) {
    minFrequency
    workDayQuantity
    listStudentSummary {
        studentId
        studentName
        classQuantity
        frequency
    }
    listCycleClosingAttendanceDate {
      dateInMilli
      closingAttendanceStudent {
        studentId
        classes {
          attendanceId
          classSequence
          attendance
          attendanceJustification
          editable
        }
      }
    }
  }
}
`;
}

export function cycleClosingConsolidationWrapperByCycleClosing(
  selectedClosingProcess
) {
  return `{
  cycleClosingConsolidationWrapperByCycleClosing(cycleClosing: {
    id: ${selectedClosingProcess.id}
    cycleNumber: ${selectedClosingProcess.cycleNumber}
    schoolClass: {
          id: ${selectedClosingProcess.schoolClass.id}
          studentsQuantity: 0
          updaterId: 0
          year: 0
          active: true
          capacity: 0
          courseStep: {
            id: ${selectedClosingProcess.schoolClass.courseStep.id}
            cycleQuantity: 0
            course: { 
              id: ${selectedClosingProcess.schoolClass.courseStep.course.id}
              excluded:false, 
              updaterId: 0, 
              useGridSchedule: true, 
              active: true
            }
          }
    }
    subject: {
          id: ${selectedClosingProcess.subject.id}
          termFilterId: 0
          updaterId: 0
          subjectLevelFilterId: 0
          active: true
    }
  }) 
  {
    minFrequency
    minAverage
    consolidationData {
      studentId
      studentName
      frequency
      average
    }
  }
}`;
}

export function cycleClosingGradeDataSave(values) {
  const {
    evaluativeActivitiesGrid,
    subject,
    schoolClass,
    cycleNumber,
    professor,
  } = values;
  const closingGradeInfo = evaluativeActivitiesGrid.closingData.map((item) => {
    return {
      average: item.averageCopy || 0,
      classCouncil: item.classCouncil || 0,
      finalAverage: item.average ? Number(item.average) : 0,
      student: {
        id: item.studentId,
        updaterId: 0,
        active: true,
        activeOnLoggedPeriod: true,
        legacyId: 0,
        dateOfBirth: 0,
      },
    };
  });
  return `mutation {
    cycleClosingSave(
        cycleClosing: {
            id: ${values.id}
            cycleNumber: ${cycleNumber}
            cycleClosed: false
            schoolClass: {
                id: ${schoolClass.id},
                studentsQuantity:0
                updaterId:0
                year:0
                active: true
                capacity:0
            }
            subject: {
                id: ${subject.id}
                termFilterId: 0
                updaterId: 0
                subjectLevelFilterId: 0
                active: true
            }
            professor: {
                id: ${professor.id},
                usuarioChatInterno: false
                ativo:true  
                pedagogicAdm: false
                updaterId:0
                active: true
                usuarioChat: false
            }
            closingGradeInfo: ${JSON.stringify(closingGradeInfo).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )}
        }
    ) {id}
}`;
}

export function attendanceGradeDataSave(values, cycleClosingProcessId = 0) {
  const { attendanceWrapper, schoolClass, subject, cycleNumber } = values;
  const attendanceStudent = [];
  attendanceWrapper.listCycleClosingAttendanceDate.forEach((attendanceDate) => {
    attendanceDate.closingAttendanceStudent.forEach((attendance) => {
      attendance.classes.forEach((classe) => {
        attendanceStudent.push({
          attendanceId: classe.attendanceId,
          schoolClassId: schoolClass.id,
          courseStepId: schoolClass.courseStep.id,
          subjectId: subject.id,
          studentId: attendance.studentId,
          dateInMilli: attendanceDate.dateInMilli,
          classSequence: classe.classSequence,
          cycle: cycleNumber,
          attendanceType: classe.attendance,
        });
      });
    });
  });
  return `mutation {
    cycleClosingAttendanceDataSave(cycleClosingAttendanceData: ${JSON.stringify(
      attendanceStudent
    ).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}, cycleClosingProcessId: ${cycleClosingProcessId}) {attendanceId}
}`;
}

export function closeCycleMutation(values) {
  const { subject, schoolClass, cycleNumber, professor } = values;
  return `mutation {
    cycleClosingSave(
        cycleClosing: {          
            id: ${values.id}
            cycleNumber: ${cycleNumber}
            cycleClosed: true
            workDayQuantity: ${
              values.workDayQuantity ? values.workDayQuantity : 0
            }
            schoolClass: {
                id: ${schoolClass.id},
                studentsQuantity:0
                updaterId:0
                year:0
                active: true
                capacity:0
            }
            subject: {
                id: ${subject.id}
                termFilterId: 0
                updaterId: 0
                subjectLevelFilterId: 0
                active: true
            }
            professor: {
                id: ${professor.id},
                usuarioChatInterno: false
                ativo:true  
                pedagogicAdm: false
                updaterId:0
                active: true
                usuarioChat: false
            }            
        }
    ) {id}
}`;
}
